import { Component } from "@angular/core";

@Component({
  selector: "app-revenue-card-skeleton",
  imports: [],
  templateUrl: "./revenue-card-skeleton.component.html",
  styleUrl: "./revenue-card-skeleton.component.scss",
})
export class RevenueCardSkeletonComponent {}
